import { render } from "./StreamsManageAudienceEmailCapture.vue?vue&type=template&id=1cdb1b9c"
import script from "./StreamsManageAudienceEmailCapture.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageAudienceEmailCapture.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/StreamsManageAudienceEmailCapture.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cdb1b9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cdb1b9c', __exports__)) {
    api.reload('1cdb1b9c', __exports__)
  }
  
  module.hot.accept("./StreamsManageAudienceEmailCapture.vue?vue&type=template&id=1cdb1b9c", () => {
    api.rerender('1cdb1b9c', render)
  })

}


export default __exports__